import general from './general'
import menu from './menu'
import pages from './pages'

export default {
    general,
    menu,
    pages
}